import * as React from 'react'

const SvgArrowUpIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2.5L3.75 8.75l.881.881 4.744-4.737V18.75h1.25V4.894l4.744 4.737.881-.881L10 2.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgArrowUpIcon
